import { GET_TARGET } from "./type";

const initalState = {
  targetData: [],
};

const targetDataSequenceReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TARGET:
      return {
        ...state,
        targetData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default targetDataSequenceReducer;
